import { isFeatureEnabled } from 'owa-feature-flags';
import { getStore } from '../store/store';

export default function isOptionAllowed(allowedOptionFlags: string[]) {
    return (
        !isFeatureEnabled('fwk-getAllowedOptions') ||
        allowedOptionFlags.every(requiredFlag => getStore().allowedOptions.includes(requiredFlag))
    );
}
